import { createContext, useContext } from 'react';
import type { ChecklistRootCtxValue } from '../types';

/** Internal shell context. Consumed by `Checklist.Item`, never exported publicly. */
export const ChecklistRootContext = createContext<ChecklistRootCtxValue | null>(null);

export function useChecklistRoot(): ChecklistRootCtxValue {
  const ctx = useContext(ChecklistRootContext);
  if (!ctx) {
    throw new Error('Checklist.Item must be used within a <Checklist>');
  }
  return ctx;
}
